module.exports = __webpack_public_path__ + "img/app.3262a39a.png";